"use client";

import { useEffect, useRef } from "react";
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "@/components/ui/carousel";

const SLIDE_INTERVAL_MS = 5000;

const HOME_BANNER_SLIDES = [
    {
        src: "/images/home-banner/1.jpg",
        alt: "Campagne Vacances 2026 – Découvrez les plus belles plages de Côte d'Ivoire",
    },
    {
        src: "/images/home-banner/2.jpg",
        alt: "Campagne Vacances 2026 – Littoral ivoirien",
    },
    {
        src: "/images/home-banner/3.jpg",
        alt: "Campagne Vacances 2026 – Vivez un été d'exception en Côte d'Ivoire",
    },
];

export default function HomeBannerVideo() {
    const nextRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        const next = nextRef.current;
        if (!next) return;

        const interval = setInterval(() => {
            next.click();
        }, SLIDE_INTERVAL_MS);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="w-full bg-slate-900">
            <Carousel className="w-full" opts={{ loop: true }}>
                <CarouselContent>
                    {HOME_BANNER_SLIDES.map((slide) => (
                        <CarouselItem key={slide.src}>
                            <img
                                src={slide.src}
                                alt={slide.alt}
                                width={1920}
                                height={500}
                                className="block h-auto w-full max-h-[500px] min-h-[200px] object-cover"
                            />
                        </CarouselItem>
                    ))}
                </CarouselContent>
                <CarouselPrevious className="left-4 border-white/40 bg-black/30 text-white hover:bg-black/50" />
                <CarouselNext
                    ref={nextRef}
                    className="right-4 border-white/40 bg-black/30 text-white hover:bg-black/50"
                />
            </Carousel>
        </div>
    );
}
